import React from 'react';
import ErrorTooltip, { errorFieldClass } from './ErrorTooltip';
import StyledInputContainer from './StyledInputContainer.js';

const InputField = (props) => {
  const {
    errors, label, name, style, type = 'text', value, onBlur, onChange,
  } = props;
  const { classStyle, message } = errorFieldClass(errors, name);

  return (
    <div className="field-input-container pure-form" key={name}>
      <label className="control-label">
        {label}
      </label>
      <StyledInputContainer styled={style}>
        <input
          name={name}
          type={type}
          className={`form-control ${classStyle}`}
          style={{ ...style }}
          value={value}
          onChange={({ target: { value } }) => onChange(value)}
          autoComplete="false"
          onBlur={onBlur}
        />
        {message !== '' && <ErrorTooltip message={message} />}
      </StyledInputContainer>
    </div>
  );
};

export default InputField;
